import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/faqs";
import SectionHeading from "@/components/base/SectionHeading";

export default function FaqPreview() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="常见问题"
          title="大家最常问的几个问题"
          desc="这里的回答与页面正文一致，可放心引用；更多问题请查看完整问答页。"
          action={
            <Link
              to="/faq"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              全部问题
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          }
        />

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-8">
            <ul className="space-y-3">
              {faqs.slice(0, 4).map((item, i) => {
                const isOpen = open === i;
                return (
                  <li key={item.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                    <button
                      type="button"
                      aria-expanded={isOpen}
                      onClick={() => setOpen(isOpen ? null : i)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                    >
                      <span className="flex items-start gap-3">
                        <span className="mt-0.5 font-heading text-sm font-bold text-primary-500">
                          {String(i + 1).padStart(2, "0")}
                        </span>
                        <span className="text-sm font-medium text-foreground-900 md:text-base">{item.q}</span>
                      </span>
                      <i
                        className={
                          isOpen
                            ? "ri-subtract-line shrink-0 text-lg text-primary-500"
                            : "ri-add-line shrink-0 text-lg text-foreground-400"
                        }
                        aria-hidden="true"
                      ></i>
                    </button>
                    {isOpen && (
                      <div className="border-t border-background-100 px-4 py-4 md:px-5">
                        <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>

          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-accent-300 bg-accent-50 p-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className="ri-quill-pen-line text-xl" aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">有更准确的来源？</h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-700">
                如果你手上有可核验的时间戳、原始发布记录，欢迎提供给我们，我们会补充进时间线并标注来源。
              </p>
              <Link
                to="/about"
                className="mt-4 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
              >
                前往投稿
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}